import { render, staticRenderFns } from "./ShippedByFNS-ColumnAlpha.vue?vue&type=template&id=96b5cbf4&"
import script from "./ShippedByFNS-ColumnAlpha.vue?vue&type=script&lang=js&"
export * from "./ShippedByFNS-ColumnAlpha.vue?vue&type=script&lang=js&"
import style0 from "./ShippedByFNS-ColumnAlpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports